// extracted by mini-css-extract-plugin
export default {"chip":"TagCrumbs_chip__1ZZdk"};